import { SubmitAllDocumentsActions } from "./SubmitDocumentsForApprovalAction";

const initialState = {
  submitAllLoading: false,
  submitAllData: "",
  submitAllError: "",
};

const SubmitDocumentsForApprovalReducer = (state = initialState, action) => {
  switch (action.type) {
    case SubmitAllDocumentsActions.SUBMIT_ALL_DOCUMENTS_SUCCESS:
      return {
        ...state,
        submitAllData: action.payload,
        submitAllLoading: false,
      };

    case SubmitAllDocumentsActions.SUBMIT_ALL_DOCUMENTS_ERROR:
      return {
        ...state,
        submitAllError: action.payload,
        submitAllLoading: false,
      };

    case SubmitAllDocumentsActions.SUBMIT_ALL_DOCUMENTS_LOADING:
      return {
        ...state,
        submitAllLoading: true,
      };

    default:
      return state;
  }
};

export default SubmitDocumentsForApprovalReducer;
